import type { ThemeFooterProps } from "@op/puck-types";
import { LazyComponent } from "../../../utils/LazyComponent";

const ThemeFooter = (props: ThemeFooterProps) => {
  return <LazyComponent<ThemeFooterProps> name="ThemeFooter" {...props} />;
};

export default ThemeFooter;
